const elencoMailForm = {
  mail: null,
  tipologia: null
};

export { elencoMailForm as default }
